// client/src/components/shell/AppChromeLayout.js
// Layout route for app-level pages (/, /teams, /whoami).
// Renders the app-level top bar and drawer, then the Outlet.
//
// Deliberately NOT wrapping /teams/:teamId/* (which uses PfTopBar/PfTabBar
// as its own scoped chrome) or /kitchen-sink (which is a bare
// design-system reference route).

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { PfAppTopBar } from './PfAppTopBar';
import { PfAppDrawer } from './PfAppDrawer';
import { useOrg } from '../../lib/OrgProvider';

export function AppChromeLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { signOut } = useOrg();

  return (
    <>
      <PfAppTopBar onMenuClick={() => setMenuOpen(true)} />
      <PfAppDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        onSignOut={signOut}
      />
      <Outlet />
    </>
  );
}